module.exports = __webpack_public_path__ + "img/ic_process_no3.a5039d17.png";